import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type JournalistEnquiry from "./JournalistEnquiry";

@Model()
class JournalistEnquiryTag extends ApplicationRecord {
  static jsonapiType = "journalist_enquiry_tags";

  @Attr() color: string;

  @BelongsTo() journalistEnquiry: JournalistEnquiry;

  @Attr() journalistEnquiryId: number;

  @Attr() label: string;
}

export default JournalistEnquiryTag;
